export default __webpack_public_path__ + "static/media/fastTime.4c96fa65.svg";